import { createContext, useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FullScreenDotLoader } from "@components/UI";
import { useSearchInfo } from "@hooks/useSearchInfo";

export const ScanToolSearchInfoContext = createContext(null);

const ScanToolGuard = ({ requiredTool, children }) => {
  const { t } = useTranslation();
  const searchInfo = useSearchInfo();
  const { scanToolList, fetchSearchInfo, isFetched } = searchInfo;
  const { verificationTypeCd } = useParams();

  useEffect(() => {
    fetchSearchInfo();
  }, []);

  if (!isFetched) return (
    <FullScreenDotLoader
      text={t("common.page-loading")}
      size={80}
      speedMultiplier={1.2}
    />
  )

  const wrapWithSearchInfo = (content) => (
    <ScanToolSearchInfoContext.Provider value={searchInfo}>
      {content}
    </ScanToolSearchInfoContext.Provider>
  );

  // MODE 1: Prop-based
  if (requiredTool) {
    const hasTool = scanToolList?.some((t) => t.value === requiredTool);

    if (!hasTool) return <Navigate to="/404" replace />;
    return wrapWithSearchInfo(children);
  }
  // MODE 2: URL-based (requests/:id/:tool)
  if (verificationTypeCd) {
    const hasTool = scanToolList?.some((t) => t.value === verificationTypeCd);

    if (!hasTool) return <Navigate to="/404" replace />;
    return wrapWithSearchInfo(children);
  }

  return <Navigate to="/404" replace />;  
};

export default ScanToolGuard;